import React from "react";
import { string, bool, shape, number } from "prop-types";
import { ReactComponent as Hide } from "styles/images/figma/icon/eyehide.svg";
import { ReactComponent as Show } from "styles/images/figma/icon/eye.svg";
import * as i18nUtils from "util/i18n";

import { calculateScoreStrengthPassword } from "util/settings";

import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";

import I18n from "pages/_components/I18n";
import { isEmpty } from "lodash";

class HideInput extends React.Component {
    inputRef = React.createRef();

    static propTypes = {
        field: shape({}).isRequired,
        form: shape({}).isRequired,
        autoComplete: string,
        maxLength: number,
        autoFocus: bool,
        showStrength: bool,
        strength: number,
        copyEnabled: bool,
        className: string,
        inputRef: shape().isRequired,
    };

    static defaultProps = {
        autoComplete: "on",
        maxLength: 20,
        autoFocus: false,
        showStrength: false,
        strength: 0,
        copyEnabled: "true",
        className: "",
    };

    state = {
        isVisible: false,
        isEmpty: true,
    };

    componentDidUpdate(prevProps, prevState) {
        const { isVisible } = this.state;
        if (isVisible !== prevState.isVisible && prevProps && this.inputRef?.current) {
            this.inputRef.current.focus();
        }
    }

    handleOnChange = (event) => {
        this.setState({
            scoreStrengthPass: calculateScoreStrengthPassword(event.target.value),
        });
        this.setState({ isEmpty: event.target.value.length === 0 });
    };

    toggleIsVisible = () => {
        this.setState((prevState) => ({ ...prevState, isVisible: !prevState.isVisible }));
    };

    revealFunction = () => {
        const { isVisible } = this.state;
        return (
            <>
                <Button className="btn-only-icon" block={false} onClick={this.toggleIsVisible}>
                    <I18n
                        id={
                            isVisible
                                ? "login.step1.secondFactor.maskPassword.a11y"
                                : "login.step1.secondFactor.unmaskPassword.a11y"
                        }
                        componentProps={{ className: "visually-hidden" }}
                    />
                    {isVisible ? <Show className="svg-image" /> : <Hide className="svg-image" />}
                </Button>
            </>
        );
    };

    render() {
        const { isVisible, scoreStrengthPass, isEmpty } = this.state;
        const { showStrength, copyEnabled, strength, className } = this.props;

        const finalStrength = strength || scoreStrengthPass;
        let strengthText = null;
        const defaultColor = "#F0F0F0";
        let strengthColor = defaultColor;
        let strengthSecondColor = defaultColor;
        let barColors = [strengthColor, strengthColor, strengthColor];
        if (finalStrength > 66) {
            strengthText = i18nUtils.get("password.strength.strong", "Fuerte");
            strengthColor = "#35EEC8";
            strengthSecondColor = "#C8F2EA";
            barColors = [strengthColor, strengthColor, strengthColor];
        } else if (finalStrength > 33) {
            strengthText = i18nUtils.get("password.strength.medium", "Media");
            strengthColor = "#EF6C00";
            strengthSecondColor = "#FFEDB6";
            barColors = [strengthColor, strengthColor, defaultColor];
        } else if (finalStrength > 0) {
            strengthText = i18nUtils.get("password.strength.weak", "Débil");
            strengthColor = "#D32F2F";
            strengthSecondColor = "#FFCDD2";
            barColors = [strengthColor, defaultColor, defaultColor];
        }

        return (
            <div className="form-group">
                {showStrength && !!strengthText && (
                    <span
                        style={{
                            padding: "4px 8px",
                            fontWeight: "bold",
                            borderRadius: 50,
                            color: "#222221",
                            marginLeft: "auto",
                            fontSize: "12px",
                            backgroundColor: strengthSecondColor,
                        }}>
                        {strengthText}
                    </span>
                )}
                <TextField
                    {...this.props}
                    inputRef={this.inputRef}
                    type={"text"}
                    style={{
                        fontFamily: isVisible ? "inherit" : isEmpty ? "inherit" : "mono",
                        WebkitTextSecurity: isVisible ? "none" : isEmpty ? "none" : "disc",
                    }}
                    inputFunctions={this.revealFunction()}
                    handleOnChange={this.handleOnChange}
                    autoCapitalize="none"
                    copyEnabled={copyEnabled}
                    className={className}
                />
                {showStrength && (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div
                            style={{
                                width: "32%",
                                borderRadius: 6,
                                height: 6,
                                backgroundColor: barColors[0],
                            }}
                        />
                        <div
                            style={{
                                width: "32%",
                                borderRadius: 6,
                                height: 6,
                                backgroundColor: barColors[1],
                            }}
                        />
                        <div
                            style={{
                                width: "32%",
                                borderRadius: 6,
                                height: 6,
                                backgroundColor: barColors[2],
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default HideInput;
